<template>
  <ng-table
    class="ng-table"
    :columns="columns"
    :params="params"
    :rowKey="row => row.batch_id"
    :request="$axios.Marklibrary_doneServeList"
    :load.sync="loadTable"
    :reload.sync="reloadTable"
    :scroll="{y: scrollyHeight - 20}"
  >
    <!-- 头像 -->
    <template slot="lib_logo_url" slot-scope="text, scope">
      <ng-image
        class="table-header"
        :src="scope.lib_logo_url ? `${scope.lib_logo_url}?x-oss-process=style/thumb_10` : $var.defaultHeader"
        @error="({target}) => target.src = $var.defaultHeader"
      />
    </template>

    <template slot="priority" slot-scope="text">
      <span v-html="$options.filters.toLevelName(text)"></span>
    </template>

    <template slot="number" slot-scope="text">
      <span>{{`批次${text}`}}</span>
    </template>

    <template slot="operation" slot-scope="text, scope">
      <router-link
        v-if="$root.$checkAuth($auth[authName] && $auth[authName].info)"
        :to="`/librarymark/musicmanage/${scope.batch_id}?from=${$var.Common.fourth}`"
        class="m-right-ms"
      >查看</router-link>
      <a-button
        class="m-right-ms"
        type="link"
        @click="goRelease(scope)"
        :disabled="!scope.op_online"
      >上线</a-button>
    </template>
  </ng-table>
</template>

<script>
  import {tableMixins} from '@/mixins';

  import * as TabCol from '@/config/columns';

  const columns = [
    TabCol.colId,
    TabCol.portrait('封面', 'lib_logo_url'),
    TabCol.commonKey('曲库名称', 'lib_name', {ellipsis: true}),

    TabCol.commonKey('交付时间', 'update_at'),
    TabCol.commonKey('优先级', 'priority', '', true),
    TabCol.commonKey('音乐数量', 'music_num'),
    TabCol.operation('100px')
  ]

  export default {
    data() {
      return {
        columns,
        tableList: [],
        // params: {},
      }
    },

    props: {
      authName: String,
      scrollyHeight: {
        type: Number,
        default: 400
      },
      params:Object
    },

    mounted() {
      // this.params = {page: this.$route.query.page || 1};
    },

    mixins: [
      tableMixins
    ],

    methods: {
      goRelease(scope) {
        let vm = this;

        this.$confirm({
          width: '480px',
          title: '确认要发起上线吗？',
          onOk() {
            return new Promise((resolve, reject) => {
              vm.releaseTag(scope, resolve, reject);
            });
          }
        });
      },

      releaseTag(scope, next, reject) {
        this.$axios.Marklibrary_TaskRelease({batch_id: scope.batch_id}).then(res => {
          const data = res.data;

          if (data && data.code == 0) {
            this.$message.success('发起上线成功');
            next();

            setTimeout(() => {
              this.loadTableData();
            }, 500);
          } else {
            reject()
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .ant-table td {
    white-space: nowrap;
  }
</style>
